<template>
  <div class="max-w-7xl mx-auto">
    <MembershipProductEditForm
      v-if="product"
      :product="product"
      @updated="refresh"
      :account-type-options="accountTypeOptions"
      :category-options="categoryOptions"
      :tag-options="tagOptions"
      :feature-options="featureOptions"
    />
  </div>
</template>

<script>
import MembershipProductEditForm from './components/MembershipProductEditForm.vue';

export default {
  components: { MembershipProductEditForm },
  inject: [
    'product',
    'categoryOptions',
    'tagOptions',
    'featureOptions',
    'accountTypeOptions',
    'refresh',
  ],
};
</script>
